import {
  VantageSiteBuildStatus,
  VantageSiteResponse,
  VantageSitesBuildRequest,
  VantageSitesBuildResponse,
  VantageSitesBuildStatusResponse,
  VantageSitesCustomDomainResponse
} from "@/libwyze-common/api/types";
import {JSON_OBJECT} from "../shared/json/helpers";
import {
  getVantageSiteBuildStatusUrl,
  getVantageSiteBuildUrl,
  getVantageSiteByIdUrl,
  getVantageSiteCustomDomainUrl
} from "@/libwyze-shared/types";
import {Site} from "./types";

export class VantageApi {

  private static instance: VantageApi;

  static getInstance(): VantageApi {
    if (!VantageApi.instance) {
      VantageApi.instance = new VantageApi();
    }
    return VantageApi.instance;
  }

  private constructor() {
  }

  private async fetchVantageSite(url: string): Promise<Site | undefined> {
    const resp = await (await fetch(url)).json() as VantageSiteResponse;
    let site: Site;
    if (resp) {
      site = JSON_OBJECT.deserializeObject(resp.site, Site);
      if (site) {
        await site.onAfterItemDeserialized();
      }
    }
    return site;
  }

  async fetchVantageSiteById(practiceId: string, siteId: string): Promise<Site | undefined> {
    return this.fetchVantageSite(getVantageSiteByIdUrl(practiceId, siteId));
  }

  async fetchVantageSiteBuildStatus(practiceId: string, siteId: string): Promise<VantageSiteBuildStatus | undefined> {
    const resp = await (await fetch(getVantageSiteBuildStatusUrl(practiceId, siteId))).json() as VantageSitesBuildStatusResponse;
    return resp?.buildStatus;
  }

  async requestVantageSiteBuild(practiceId: string, siteId: string): Promise<VantageSiteBuildStatus | undefined> {
    const resp = await (await fetch(getVantageSiteBuildUrl(), {
      method: 'POST',
      headers: {
        "content-type": "application/json",
      },
      body: JSON.stringify({
        practiceId,
        siteId,
      } as VantageSitesBuildRequest)
    })).json() as VantageSitesBuildResponse;
    return resp?.buildStatus;
  }

  async requestVantageSiteCustomDomainAdd(practiceId: string, siteId: string, customDomain: string): Promise<boolean> {
    const resp = await (await fetch(getVantageSiteCustomDomainUrl(), {
      method: 'PUT',
      headers: {
        "content-type": "application/json",
      },
      body: JSON.stringify({
        practiceId,
        siteId,
        name: customDomain,
      } as VantageSitesBuildRequest)
    })).json() as VantageSitesCustomDomainResponse;
    return resp?.status?.code === 200;
  }

  async requestVantageSiteCustomDomainDelete(practiceId: string, siteId: string, customDomain: string): Promise<boolean> {
    const resp = await (await fetch(getVantageSiteCustomDomainUrl(), {
      method: 'DELETE',
      headers: {
        "content-type": "application/json",
      },
      body: JSON.stringify({
        practiceId,
        siteId,
        name: customDomain,
      } as VantageSitesBuildRequest)
    })).json() as VantageSitesCustomDomainResponse;
    return resp?.status?.code === 200;
  }
}